import { render, staticRenderFns } from "./LayerWidget.vue?vue&type=template&id=582c168b&scoped=true"
import script from "./LayerWidget.vue?vue&type=script&lang=js"
export * from "./LayerWidget.vue?vue&type=script&lang=js"
import style0 from "./LayerWidget.vue?vue&type=style&index=0&id=582c168b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582c168b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('582c168b')) {
      api.createRecord('582c168b', component.options)
    } else {
      api.reload('582c168b', component.options)
    }
    module.hot.accept("./LayerWidget.vue?vue&type=template&id=582c168b&scoped=true", function () {
      api.rerender('582c168b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/designer/widgets/LayerWidget.vue"
export default component.exports